import { SwitcherItem } from "./switcher-item";

export class Switcher {
  constructor(
    public name: string,
    public items: SwitcherItem[],
  ) {
    if (!items || items.length !== 12) {
      throw new Error("Must contain 12 switcher items");
    }
  }
  public clone(): Switcher {
    return new Switcher(
      this.name,
      this.items.map((i) => i.clone()),
    );
  }
}
